import { render, staticRenderFns } from "./page_about_us.vue?vue&type=template&id=219091fa&scoped=true"
import script from "./page_about_us.vue?vue&type=script&lang=js"
export * from "./page_about_us.vue?vue&type=script&lang=js"
import style0 from "./page_about_us.vue?vue&type=style&index=0&id=219091fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219091fa",
  null
  
)

export default component.exports